import React, { FC } from 'react';
import ICONS from 'components/Icons';
import './style.scss';

export interface PaymentMethodViewProps {
  last4?: string;
  bankName?: string;
  cardBrand?: string;
  paymentMethodType?: string;
}

export const PaymentMethodView: FC<PaymentMethodViewProps> = ({ last4, bankName, cardBrand, paymentMethodType }) => {
  const paymentMethod = {
    ach: <>{`${bankName?.toUpperCase() || ''} •••• ${last4 || ''} `}</>,
    card: (
      <>
        {ICONS[cardBrand?.toLocaleLowerCase() || '']}
        {last4 && `•••• ${last4} `}
      </>
    ),
    offline: <>{ICONS['cash_or_check']} Cash or Check</>,
  };

  return <b className="row align-center last-4">{paymentMethod[paymentMethodType as keyof typeof paymentMethod]}</b>;
};
